import Immutable from 'seamless-immutable';
import { styleguide } from "../../styleguide";
export default Immutable.from({
  label: {
    fontFamily: styleguide.font.family.regular,
    fontSize: styleguide.font.size.large,
    lineHeight: styleguide.lineHeight.medium,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordBreak: 'break-all'
  }
});
//# sourceMappingURL=ShowMoreButton.styles.js.map